import React from "react";
import { Button, Grid } from "@mui/material";
import { GridContainer } from "./FormActionButtons.styles";
import { useHistory } from "react-router-dom";

interface FormActionButtonsProps {
	loading?: boolean;
}

export default function FormActionButtons({ loading = false }: FormActionButtonsProps) {
	const { push } = useHistory();
	const onCancel = () => push("/questions");

	return (
		<GridContainer container item spacing={4} justifyContent={"flex-end"}>
			<Grid item>
				<Button
					type={"button"}
					onClick={onCancel}
					disabled={loading}
					variant={"outlined"}
					color={"secondary"}
					size={"large"}
				>
					Отменить
				</Button>
			</Grid>
			<Grid item>
				<Button type={"submit"} disabled={loading} variant={"outlined"} color={"primary"} size={"large"}>
					Сохранить
				</Button>
			</Grid>
		</GridContainer>
	);
}
